/**
 * Suspensão da geração de boletos (adimplência) do credor.
 *
 * Quando o admin da Direto suspende a geração, a API de recorrência passa a
 * devolver credor.geracao_boleto_ativa = false e recusa novas emissões com
 * HTTP 409 e codigo GERACAO_BOLETO_SUSPENSA. Boletos já emitidos, 2ª via,
 * baixa e cancelamento continuam disponíveis.
 */

export const CODIGO_GERACAO_SUSPENSA = 'GERACAO_BOLETO_SUSPENSA';

export const MENSAGEM_GERACAO_SUSPENSA =
    'A geração de novos boletos está suspensa para a sua empresa. Os boletos já emitidos continuam válidos.';

/**
 * @param {object|false|null|undefined} credorData
 * @returns {boolean}
 */
export function isGeracaoBoletoSuspensa(credorData) {
    return Boolean(credorData) && typeof credorData === 'object' && credorData.geracao_boleto_ativa === false;
}

/**
 * Indica se o erro da API é o bloqueio por geração suspensa.
 * @param {any} error - erro do axios
 * @returns {boolean}
 */
export function isErroGeracaoSuspensa(error) {
    return error?.response?.status === 409 && error?.response?.data?.codigo === CODIGO_GERACAO_SUSPENSA;
}
